"use strict";
var core_1 = require('@angular/core');
var rxjs_1 = require('rxjs');
var sound_types_1 = require('./sound-types');
var p5 = require('p5');
var p5sound = require('p5sound');
;
var SoundService = (function () {
    function SoundService() {
        this.mainGainNode = new p5.Gain();
        this.p5 = new p5(function (p) {
            p.setup = function (arg) {
                p.createCanvas(100, 100);
            };
        });
        this.mainGainNode.connect();
    }
    SoundService.prototype.playMidiNote = function (note, time, gainNode, attackLevel, releaseLevel, attackTime, decayTime, susPercent, releaseTime) {
        if (time === void 0) { time = 0; }
        if (gainNode === void 0) { gainNode = this.mainGainNode; }
        if (attackLevel === void 0) { attackLevel = 1.0; }
        if (releaseLevel === void 0) { releaseLevel = 0; }
        if (attackTime === void 0) { attackTime = 0.001; }
        if (decayTime === void 0) { decayTime = 0.2; }
        if (susPercent === void 0) { susPercent = 0.2; }
        if (releaseTime === void 0) { releaseTime = 0.5; }
        sound_types_1.playSound({
            time: time,
            type: sound_types_1.SoundType.MIDI_OSC,
            gain: this.mainGainNode,
            p5: this.p5,
            data: {
                note: note,
                attackLevel: attackLevel,
                releaseLevel: releaseLevel,
                attackTime: attackTime,
                decayTime: decayTime,
                susPercent: susPercent,
                releaseTime: releaseTime,
            },
        });
    };
    SoundService.prototype.setAmplitude = function (amplitude) {
        this.mainGainNode.amp(amplitude, 0.1);
    };
    SoundService.prototype.playSequence = function (getNextSoundsAfterBeat, bpm, beatOffset) {
        var _this = this;
        if (bpm === void 0) { bpm = 120; }
        if (beatOffset === void 0) { beatOffset = 0; }
        var startTime;
        var gain = new p5.Gain();
        gain.connect(this.mainGainNode);
        var progress = new rxjs_1.Subject();
        var stopped = false;
        var stop = function () {
            // console.info('stop');
            gain.amp(0, 0.1);
            setTimeout(function () {
                gain.disconnect();
                gain.dispose();
            }, 100);
            stopped = true;
        };
        var currentPosition = function () {
            return Math.max(beatsElapsed, 0);
        };
        var beatsElapsed = beatOffset;
        var lastScheduledBeat = beatOffset - 0.02;
        var sounds = getNextSoundsAfterBeat(lastScheduledBeat);
        var beatsToSecondsFactor = bpm / 60;
        var retriggerTimingFrame = function () {
            if (!stopped) {
                requestAnimationFrame(function () {
                    startTime = startTime
                        || _this.p5.getAudioContext().currentTime + 0.005;
                    var elapsedTime = _this.p5.getAudioContext().currentTime - startTime;
                    beatsElapsed = elapsedTime * beatsToSecondsFactor + beatOffset;
                    // notify progress
                    if (!stopped && beatsElapsed >= 0) {
                        progress.next(beatsElapsed);
                    }
                    while (sounds.length && lastScheduledBeat < beatsElapsed
                        + 0.2 * beatsToSecondsFactor) {
                        // queue this batch of sounds
                        sounds.map(function (sound) {
                            var noteBeatOffset = sound.time - beatsElapsed;
                            if (noteBeatOffset > 0) {
                                var timeOffset = noteBeatOffset / beatsToSecondsFactor;
                                sound_types_1.playSound({
                                    time: timeOffset,
                                    type: sound_types_1.SoundType.MIDI_OSC,
                                    gain: gain,
                                    p5: _this.p5,
                                    data: sound,
                                });
                            }
                        });
                        // progress to the next beat position
                        lastScheduledBeat = sounds[0].time;
                        sounds = getNextSoundsAfterBeat(lastScheduledBeat);
                    }
                    retriggerTimingFrame();
                });
            }
        };
        retriggerTimingFrame();
        return { stop: stop, progress: progress, currentPosition: currentPosition };
    };
    SoundService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], SoundService);
    return SoundService;
}());
exports.SoundService = SoundService;
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./src/services/sound/index.ts
 ** module id = 430
 ** module chunks = 1
 **/